import { Routes } from "@angular/router";
import { AuthGuard } from "./shared/guards/auth.guard";
import { ProfileCompleteGuard } from "./shared/guards/profile-complete.guard";

export const APP_ROUTES: Routes = [
  { path: "auth/native", loadComponent: () => import("./auth/native-handoff.page").then(m => m.NativeHandoffPage) },
  { path: "auth/native/start", redirectTo: "auth/native", pathMatch: "full" },
  { path: "auth/native/callback", redirectTo: "auth/native", pathMatch: "full" },
  {
    path: "ask",
    canActivate: [AuthGuard],
    loadComponent: () => import("./assistant/assistant.page").then(m => m.AssistantPage),
  },
  { path: "auth/website", loadComponent: () => import("./auth/website-handoff.page").then(m => m.WebsiteHandoffPage) },
  { path: "auth/action", loadComponent: () => import("./auth/email-action.page").then(m => m.EmailActionPage) },
  {
    path: "",
    redirectTo: "manage/home",
    pathMatch: "full",
  },
  {
    path: "welcome",
    loadChildren: () => import("./welcome/welcome.routes").then(m => m.WELCOME_ROUTES),
  },
  {
    path: "manage",
    loadChildren: () => import("./manage/manage.routes").then(m => m.MANAGE_ROUTES),
    canActivate: [AuthGuard, ProfileCompleteGuard],
    canActivateChild: [ProfileCompleteGuard],
  },
  {
    path: "account",
    loadChildren: () => import("./account/account.routes").then(m => m.ACCOUNT_ROUTES),
    canActivate: [AuthGuard],
  },
  {
    path: "slides",
    loadChildren: () => import("./welcome/slides/slides.routes").then(m => m.SLIDES_ROUTES),
  },
  {
    path: "error",
    loadChildren: () => import("./error/error.routes").then(m => m.ERROR_ROUTES),
  },

  // Fallback route for any errors - goes to a safe public route
  {
    path: "**",
    redirectTo: "welcome",
    pathMatch: "full",
  },
];
